import React from 'react'

import { Icon } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './styled'

export type Props = {
  label: string
  disabled?: boolean
  onRemove?: (tag: string) => void
}

export const Tag = ({ label, disabled, onRemove }: Props) => {
  const renderRemoveButton = () => {
    if (!onRemove) return null

    return (
      <S.RemoveButton
        type="button"
        onClick={() => onRemove(label)}
        data-testid="Tag.RemoveButton"
        disabled={disabled}
      >
        <Icon component={CloseIcon} height={10} />
      </S.RemoveButton>
    )
  }

  return (
    <S.Container>
      {label}
      {renderRemoveButton()}
    </S.Container>
  )
}
